import { useState } from 'react';
import { useZakeke } from 'zakeke-configurator-react';
import { ShareInterface, ShareTypes } from './share/share.model';
import { shareCreator } from './share';

const useShare = () => {
  const { getOnlineScreenshot } = useZakeke();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getShareUrl = async (width: number, height: number): Promise<string> => {
    try {
      setIsLoading(true);
      return (await getOnlineScreenshot(width, height)).originalUrl;
    } catch (ex) {
      console.error(ex);
      throw ex;
    } finally {
      setIsLoading(false);
    }
  };

  const share = (shareType: ShareTypes, url: string): void => {
    const shareImpl: ShareInterface = shareCreator(shareType, url);
    shareImpl.share();
  };

  return {
    isLoading,
    getShareUrl,
    share,
  };
};

export { useShare };
